import { render, staticRenderFns } from "./SectionWrapperDark.vue?vue&type=template&id=3684caa5&scoped=true"
import script from "./SectionWrapperDark.vue?vue&type=script&lang=js"
export * from "./SectionWrapperDark.vue?vue&type=script&lang=js"
import style0 from "./SectionWrapperDark.vue?vue&type=style&index=0&id=3684caa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684caa5",
  null
  
)

export default component.exports